export enum LocaleFormat {
  xx_dash_xx = "xx_dash_xx", // en-gb
  xx_XX = "xx_XX", // en_GB
}
